module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title_auth"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("From the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Left for Dead at Nijmegen")]), _vm._v(", 2019 Nonfiction Book of the Year.")]), _vm._v(" "), _c('p', {
    staticClass: "title_auth"
  }, [_vm._v("“We found the narrative compelling.” Julie Huggins, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Smithsonian Books")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("MIDNIGHT FLIGHT TO")]), _vm._v(" "), _c('h1', {
    staticClass: "title0"
  }, [_vm._v("NUREMBERG")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The Capture of the Nazi who put Adolf Hitler into Power")]), _vm._v(" "), _c('div', {
    staticClass: "img_containert"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/piii_01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "auth1"
  }, [_vm._v("MARCUS A. NANNINI")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/piii_02.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d57ee07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Title.vue
// module id = 63
// module chunks = 0